import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AmountWithCurrencyCell.module.scss';

const cx = classnames.bind(styles);

export type AmountWithCurrencyCellProps = {
  value: string;
  currency: string;
};

/**
 * Renders an amount beside its currency code; wraps the currency onto a
 * second line instead of truncating when the cell isn't wide enough.
 */
export const AmountWithCurrencyCell: FC<AmountWithCurrencyCellProps> = memo(
  ({ value, currency }) => {
    return (
      <div className={cx('wrapper')}>
        <span className={cx('value')}>{value}</span>
        <span className={cx('currency')}>{currency}</span>
      </div>
    );
  }
);
AmountWithCurrencyCell.displayName = 'AmountWithCurrencyCell';
